import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { DropdownItemModel } from '../helpers/objects/dropdown-item-model';
import { FormControl } from '@angular/forms';
import { LabelConfigModel } from '@fh-client-interaction-frontends/fh-label';
import { FhInputConfigModel } from '@fh-client-interaction-frontends/input-config';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ui-fh-dropdown',
  templateUrl: './fh-dropdown.component.html',
  styleUrls: ['./fh-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FhDropdownComponent implements OnInit, OnChanges, OnDestroy {
  @Input() list: DropdownItemModel[] = new Array<DropdownItemModel>();
  @Input() placeholder = '';
  @Input() class = '';
  @Input() control: FormControl | undefined;
  @Input() labelConfigs: LabelConfigModel = new LabelConfigModel();
  @Input() defaultValue: any;
  @Input() borderClass = false;
  @Input() editable = false;
  @Input() filter = false;
  @Input() filterField: string = "";
  @Input() inputConfig: FhInputConfigModel = new FhInputConfigModel();
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  value: any;
  translateSubscription: Subscription = new Subscription();

  constructor(private translateService: TranslateService, private changeDetectorRef: ChangeDetectorRef) {


  }

  ngOnInit() {
    this.BackgroundEvents();

    if (this.defaultValue != undefined) {
      this.value = this.defaultValue;
    }
    this.PrepareTranslation();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['list']) {
      this.PrepareTranslation();
    }
  }

  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
  }

  BackgroundEvents() {
    this.translateSubscription = this.translateService.onLangChange.subscribe({
      next: () => this.PrepareTranslation()
    });
    if (this.inputConfig.control != undefined) {
      this.inputConfig.control.valueChanges.subscribe({
        next: (value) => this.valueChanged()
      });
    }
  }

  PrepareTranslation() {
    if (this.list.length == 0) {
      return;
    }

    this.list.forEach((item) => {
      if (typeof item.label == 'string') {
        const translation = this.translateService.instant(item.label);
        item.translatedLabel = translation == '' ? item.label : translation;
      } else {
        item.translatedLabel = item.label;
      }
    });

    this.changeDetectorRef.detectChanges();
  }

  valueChanged() {
    this.valueChange.emit(this.value);
  }

  getLabelByValue(value: any) {
    return this.list.find((item) => item.value == value)?.label;
  }

  onDropdownOpen(){
    this.PrepareTranslation();
  }
}
